// extracted by mini-css-extract-plugin
module.exports =  {"naked":"xUKBDfgF8Z7KLgszaFrT"};